import { useTranslation } from '../../i18n';
import { Button } from '../ui/button';

interface IActionsProps {
  onCancel: () => void;
  onSave: () => void;
  saving: boolean;
  disabled: boolean;
}

const Actions = ({ onCancel, onSave, saving, disabled }: IActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end gap-3 mt-6">
      <Button variant="outline" onClick={onCancel} disabled={disabled}>
        {t('common.cancel')}
      </Button>
      <Button variant="default" onClick={onSave} disabled={disabled || saving}>
        {saving ? t('common.saving') : t('common.save_changes')}
      </Button>
    </div>
  );
};

export default Actions;
